import XLSX from 'xlsx/xlsx.js';
import { normalizeSchedulingKey, normalizeSchedulingText } from '../ticketing/partner-scheduling-patterns.js';

export const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;

export function sheetRows(sheet: XLSX.WorkSheet) {
  return XLSX.utils.sheet_to_json<Array<string | number | null>>(sheet, {
    blankrows: false,
    defval: '',
    header: 1,
  });
}

/** Index columns in partner-priority order: Primary, 2nd, 3rd, … */
export function getOrderedPartnerColumnIndexes(headers: string[]): number[] {
  const scored = headers
    .map((header, index) => ({ index, score: partnerColumnPriority(header) }))
    .filter((e): e is { index: number; score: number } => e.score !== null);
  scored.sort((a, b) => a.score - b.score || a.index - b.index);
  return scored.map(e => e.index);
}

function partnerColumnPriority(headerNorm: string): number | null {
  if (!headerNorm.includes('partner') && !headerNorm.includes('platinum')) return null;

  if (headerNorm.includes('platinum')) return 1;
  if (headerNorm.includes('primary')) return 2;

  const ord = headerNorm.match(/(\d+)(?:st|nd|rd|th)/);
  if (ord?.[1]) return parseInt(ord[1], 10) + 2;

  const partnerNum = headerNorm.match(/partner\s*(\d+)/);
  if (partnerNum?.[1]) return parseInt(partnerNum[1], 10) + 2;

  return null;
}

export function isCountryNotSupportedInNotes(notes: string): boolean {
  const t = normalizeSchedulingKey(notes);
  return t.includes('not support');
}

export function looksLikePartnerName(value: string) {
  const normalized = normalizeSchedulingText(value);
  if (!normalized) return false;
  if (normalized.includes('not support')) return false;
  if (/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(normalized)) return false;
  return !['n/a', 'na', 'none', '-', '--'].includes(normalized.toLocaleLowerCase());
}

export function getClientNameFromIndexSheet(sheetName: string) {
  const fromIndexPrefix = normalizeSchedulingText(sheetName.replace(/^Index\s*-?\s*/i, ''));
  return fromIndexPrefix || normalizeSchedulingText(sheetName);
}
